import { styles } from "./styles";
import React, { PropsWithChildren } from "react";
import { Layout, Flex, Image, Button, Modal } from "antd";
import { css } from "@emotion/css";
import { useTheme } from "@view/hooks/useTheme/useTheme";
import { LogoutOutlined } from "@ant-design/icons";
import { useControllers } from "@view/hooks/useControllers";
import { IMainLayout } from "@shared/containers/Layout/connector/__types__/UIViewController";
import withControllers from "@view/root/__proto__/withController";
import { MainLayoutController } from "@shared/containers/Layout/connector/UIViewController";
const { Header, Content } = Layout;

type Props = {};
const MainLayout = (props: PropsWithChildren<Props>): React.JSX.Element => {
  const { UIViewController } = useControllers<{
    UIViewController: IMainLayout;
  }>();

  const { theme } = useTheme();
  const [modal, contextHolder] = Modal.useModal();

  const [loading, setLoading] = React.useState(false);

  const logOut = async () => {
    setLoading(true);

    const confirm = await modal.confirm({
      title: "Are you sure you want to log out?",
    });
    if (confirm) {
      UIViewController.logout();
    }
    setLoading(false);
  };

  return (
    <Flex gap="middle" wrap="wrap">
      <Layout className={styles.layout}>
        <Header
          className={css([
            styles.header,
            { backgroundColor: theme.colors.bg2 },
          ])}
        >
          <Flex justify="space-between" align="center" gap="middle">
            <Image
              preview={false}
              src={require("@assets/images/logo-header.png")}
            />

            <Button
              onClick={logOut}
              loading={loading}
              icon={<LogoutOutlined />}
            >
              Logout
            </Button>
          </Flex>
        </Header>
        <Layout>
          {/* <Sidebar />*/}
          <Content
            className={css([
              styles.content,
              { backgroundColor: theme.colors.bg1 },
            ])}
          >
            {contextHolder}
            {props.children}
          </Content>
        </Layout>
      </Layout>
    </Flex>
  );
};

export default withControllers(MainLayoutController)(MainLayout);
